function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "71",
  height: "74",
  viewBox: "0 0 71 74",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.287 37.028c9.609-7.647 20.945-11.015 30.518-9.668 9.51 1.338 17.35 7.326 20.183 18.634l1.94-.486c-3.04-12.134-11.566-18.683-21.844-20.129-10.215-1.437-22.089 2.163-32.043 10.084l1.246 1.565z",
  fill: "#01C38F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.465 39.644l6.843 4.438 2.046-.36 4.92-6.506.489 2.785-5.777 7.636-8.032-5.208-.49-2.785z",
  fill: "#01C38F"
})));